
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M46 54a4 4 0 01-4 4H22a4 4 0 01-4-4V10a4 4 0 014-4h20a4 4 0 014 4v44zm-2-14H20v14a2 2 0 001.767 1.987L22 56h20a2 2 0 001.987-1.767L44 54V40zm-18.5 4a.5.5 0 01.5.5v7a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5h1zM42 8H22a2 2 0 00-1.987 1.767L20 10v28h24V10a2 2 0 00-1.767-1.987L42 8zM25.5 20a.5.5 0 01.5.5v13a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-13a.5.5 0 01.5-.5h1z"}})])
          )
        }
      }
    